<card [item]="componentItem" [isOsCard]="true">
  <ud-button
    [variant]="'outline'"
    [label]="'Download'"
    layout="full-width"
    (onClick)="openLink(componentItem.link)"
  ></ud-button>
</card>
